import { useAuth } from "../../../contexts/AuthContext";
import FilterListIcon from '@mui/icons-material/FilterList';
import { IconButton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
const NavUser = () => {
    const navigate = useNavigate()
    const { logout, user } = useAuth(); // Import the login function from your AuthContex
    
    const handleLogout = async (event) => {
        event.preventDefault()
        await logout()
        navigate("/", { replace: true, state: {} })
    }
    return (
        <div className="card pc-user-card hive-base-side-user-card">
            <div className="card-body hive-base-side-user-card-body">
                <div style={{display: "flex", alignItems: "center"}}>
                    <div style={{flexShrink: 0}}>
                        <div style={{backgroundColor: "rgba(104,192,255,1)", borderRadius: "50%", width: "45px", height: "45px"}}></div>
                        {/* <img src="../assets/images/user/avatar-1.jpg" alt="user" className="user-avtar wid-45" style={{borderRadius: "50%"}} /> */}
                    </div>
                    <div style={{flexGrow: 1, marginLeft: "1rem", marginRight: "0.5rem"}}>
                        <h6 className="mb-0" id="curr_user">{user && user.name}</h6>
                        <small id="user-role" style={{display: "block"}}>{user?.department || "Department"}</small>
                        <small id="user-role">{user && user.role}</small>
                    </div>
                    <IconButton className="hive-base-side-user-action">
                        <FilterListIcon/>
                    </IconButton>
                </div>
                <div className="collapse pc-user-links hive-base-side-user-links" id="pc_sidebar_userlink" style={{display: "flex"}}>
                    <div className="pt-3">
                        <Link to="/settings" className="hive-base-side-user-link">
                            <i className="ti ti-settings"></i>
                            <span>Settings</span>
                        </Link>
                        <a href="#!" onClick={handleLogout} className="hive-base-side-user-link">
                            <i className="ti ti-power"></i>
                            <span>Logout</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NavUser
